/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 11.07.2016
 *
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { Button, ButtonToolbar, Container } from 'external/react-bootstrap';
import { ScrollableDataListRV, Title } from 'plugin/liferay-widgets-react-web';

import MapConfigCopyItem from './MapConfigCopyItem';

class MapConfigCopyForm extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            selectedMapConfig: null
        };
    }

    onSelect(item){
        this.setState({
            selectedMapConfig: item
        });
    }

    handleSubmit(e){
        e.preventDefault();

        const { selectedMapConfig } = this.state;

        if (selectedMapConfig) {
            this.props.onSubmit({
                mapConfig: selectedMapConfig
            });
        }
    }

    render(){
        const { selectedMapConfig } = this.state;

        const { formData: viewableMapConfigs } = this.props;

        return (
            <Container className="py-3">
                <Title title="Kartenkonfigurationen"/>

                <p> Bitte wählen Sie eine Kartenkonfiguration aus, um diese zu kopieren. </p>

                <ScrollableDataListRV
                    list={viewableMapConfigs}
                    size="medium"
                    activeIds={selectedMapConfig}
                    className="map-config-copy-list"
                    ListItem={MapConfigCopyItem}
                    onClick={this.onSelect.bind(this)}
                />

                <ButtonToolbar>
                    <Button variant="primary" type="button" onClick={this.props.onCancel.bind(this)}>
                        Abbrechen
                    </Button>
                    <Button variant="primary" type="submit" onClick={this.handleSubmit.bind(this)}>
                        Kopieren
                    </Button>
                </ButtonToolbar>
            </Container>
        );
    }
}

MapConfigCopyForm.propTypes = {
    onCancel: PropTypes.func,
    onSubmit: PropTypes.func,
    formData: PropTypes.object
};

export default MapConfigCopyForm;



// WEBPACK FOOTER //
// ./js/components/MapConfigCopyForm.jsx